module.exports = __webpack_public_path__ + "static/media/trackpad.bbc266d2.svg";